// Firmalar Arası B2B (B2B Siparişi) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.interCompany';

export const interCompanyGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'B2B Siparişi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Aquasoft kullanan tedarikçilerinize verdiğiniz siparişler buraya kendiliğinden düşer; teslim alınca alış faturasına çevirirsiniz. Firma bağlantılarınızı da bu ekrandan yönetirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler'),
    body: t(`${G}.regions.body`, 'Filtreler ve liste'),
  },
  navItems: [
    t(`${G}.nav.orders`, 'Gelen Alış Siparişleri'),
    t(`${G}.nav.links`, 'Firma Bağlantıları'),
  ],
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu ekran ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Tedarikçiniz de Aquasoft kullanıyorsa, onun B2B mağazasından verdiğiniz sipariş sizin panelinize "gelen alış siparişi" olarak kendiliğinden gelir. Burada siparişin durumunu izler, malı teslim alır ve alış faturasına çevirirsiniz.'),
      tips: [
        t(`${G}.s1.tip1`, 'Sipariş hangi şube adına verildiyse o şubeye yazılır; şubesiz bağlantı merkeze aittir.'),
        t(`${G}.s1.tip2`, 'Şube yöneticisi yalnız kendi şubesinin siparişlerini ve bağlantılarını görür; merkez tüm şubeleri Şube filtresiyle görür.'),
      ],
    },
    {
      region: 'tabs',
      title: t(`${G}.s2.title`, '2. Firma bağlantısı kendiliğinden kurulur'),
      text: t(`${G}.s2.text`, 'Bağlantı için kod gerekmez. Müşteriniz mağazanızın giriş ekranında "Aquasoft Hesabımla" seçeneğiyle kendi Aquasoft e-posta ve şifresini kullanarak girdiğinde firması doğrulanır, gerekirse carisi otomatik açılır ve bağlantı kurulur.'),
      tips: [
        t(`${G}.s2.tip1`, 'Ayrıca carilerinizin vergi numarası (yoksa e-postası) Aquasoft\'a kayıtlı bir firmayla eşleşirse bağlantı kendiliğinden oluşur.'),
        t(`${G}.s2.tip2`, 'Firma Bağlantıları sekmesi her açıldığında carileriniz yeniden taranır; yeni eşleşmeler listeye eklenir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Gelen siparişleri süzün ve açın'),
      text: t(`${G}.s3.text`, '"Gelen Alış Siparişleri" sekmesinde Durum, Fatura (Faturalaşmış / Faturalaşmamış) ve merkezdeyseniz Şube filtrelerini kullanın. Bir satıra veya göz simgesine (Detay / Faturalaştır) tıklayınca sipariş detayı açılır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kalem sütunundaki turuncu "… eşleşmemiş" etiketi, kataloğunuzdaki bir ürünle henüz eşlenmemiş kalemleri gösterir.'),
        t(`${G}.s3.tip2`, 'Fatura sütunu: "Faturalaştı" / "Bekliyor" ve satıcının e-fatura durumu ("E-fatura bekleniyor" ya da gönderildi).'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Bağlı firmaları inceleyin'),
      text: t(`${G}.s4.text`, '"Firma Bağlantıları" sekmesinde "Devam Eden" ve "Kesilen" bağlantılar ayrı listelenir. Rolünüz sütunu ilişkiyi gösterir: Alıcı (siz sipariş veriyorsunuz) ya da Satıcı (size sipariş geliyor). Karşı Firma, Şube, Cari ve Bağlantı Tarihi de görünür.'),
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Gerekirse elle eşleştirin'),
      text: t(`${G}.s5.text`, 'Bir cariniz otomatik eşleşmediyse (vergi no / e-posta tutmuyor ve müşteri Aquasoft girişi yapmadıysa) "Elle Eşleştir" bölümünde önce bağlantısız cariyi, sonra Aquasoft firmasını seçip "Bağla"ya basın.'),
      tips: [
        t(`${G}.s5.tip1`, 'Aquasoft firması aramasında en az 3 karakter (firma adı veya vergi no) yazın.'),
        t(`${G}.s5.tip2`, 'Bu bölüm yalnız merkez panelinde görünür; şube yöneticisi panelinde yoktur.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s6.title`, '6. Bağlantıyı kesin veya yeniden bağlayın'),
      text: t(`${G}.s6.text`, 'Devam eden bir bağlantının satırındaki "Bağlantıyı kes" düğmesi onay ister. Kesildikten sonra yeni siparişler artık aynalanmaz; mevcut kayıtlar silinmez. Kesilen sekmesindeki "Yeniden bağla" ile bağlantıyı geri açarsınız; yeni siparişler tekrar aynalanır, mevcut kayıtlar değişmez.'),
      tips: [
        t(`${G}.s6.tip1`, 'Bağlantı kesme ve yeniden bağlama yalnız yönetici (merkez) panelindedir. Şube yöneticisi bağlantıları görür, kesemez.'),
      ],
    },
  ],
});
